import React from "react";
import { useGameTemplateListStateMutations } from "state/gameTemplatesState";
import AdminGameTemplateForm from "./AdminGameTemplateForm";

export default function AdminGameTemplateFormContainer(props) {
    const { initialData, onClose } = props;
    const { updateGameTemplateFromList } = useGameTemplateListStateMutations();

    const onSave = (template) => {
        updateGameTemplateFromList(template);
        onClose();
    };

    return (
        <AdminGameTemplateForm
            initialData={initialData}
            onClose={onClose}
            onSave={onSave}
        />
    )
}
